var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace userId",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("userId", "userId")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("ユーザーID")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace name",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("name", "name")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("ユーザー名")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace furigana",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("furigana", "furigana")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("ユーザー名ふりがな")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace option1",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("option1", "option1")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("備考.1")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace option2",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("option2", "option2")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("備考.2")])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-cusstom green-btn",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.search()
            }
          }
        },
        [_vm._v("検索")]
      ),
      _vm._v(" "),
      _vm.selectedUserId.length > 0
        ? _c(
            "button",
            {
              staticClass: "btn-cusstom black-btn",
              attrs: {
                type: "button",
                href: "#process",
                "data-toggle": "modal"
              },
              on: {
                click: function($event) {
                  _vm.resetStatus()
                }
              }
            },
            [_vm._v("チェックしたユーザーを無効化")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _vm.errorMessageLogs !== ""
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v("\n    " + _vm._s(_vm.errorMessageLogs) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { attrs: { id: "loading" } }, [
            _c("div", { staticClass: "loadingMsg" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "scroll-data-content" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix", staticStyle: { clear: "both" } }, [
          _c("div", { attrs: { id: "accordion" } }, [
            _c(
              "div",
              {
                staticClass: "panel-collapse collapse",
                staticStyle: { height: "0px" },
                attrs: { id: "collapseOne", "aria-expanded": "false" }
              },
              [
                _c("div", { staticClass: "panel-body" }, [
                  _c("div", { staticClass: "control-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label bolder blue display_block"
                      },
                      [_vm._v("表示項目")]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_name",
                            type: "checkbox",
                            value: "name"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "name") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "name",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v(" ユーザー名")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_furigana",
                            type: "checkbox",
                            value: "furigana"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "furigana") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "furigana",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v("ユーザー名ふりがな")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_permistion",
                            type: "checkbox",
                            value: "isAdmin"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "isAdmin") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "isAdmin",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v("組織管理権限")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_isphoneadmin",
                            type: "checkbox",
                            value: "isPhoneAdmin"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "isPhoneAdmin") >
                                -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "isPhoneAdmin",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v("ゲート設定権限")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_sharekeybevalid",
                            type: "checkbox",
                            value: "shareKeyBeValid"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(
                                  _vm.checkedColumnNames,
                                  "shareKeyBeValid"
                                ) > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "shareKeyBeValid",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v("鍵共有権限")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_status",
                            type: "checkbox",
                            value: "status"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "status") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "status",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v(" ステータス")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_option1",
                            type: "checkbox",
                            value: "option1"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "option1") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "option1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("備考.1")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_option2",
                            type: "checkbox",
                            value: "option2"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "option2") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "option2",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("備考.2")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_registered",
                            type: "checkbox",
                            value: "registered"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "registered") >
                                -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "registered",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("登録日")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_updated",
                            type: "checkbox",
                            value: "updated"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "updated") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "updated",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("更新日")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "user_isMfaSms",
                            type: "checkbox",
                            value: "isMfaSms"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "isMfaSms") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "isMfaSms",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("SMS認証")])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label bolder blue display_block"
                      },
                      [_vm._v("ページことに表示する項目")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selected,
                            expression: "selected"
                          }
                        ],
                        staticClass: "first-child last-child",
                        attrs: { id: "pageSizeOptions" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.handleSizeChange
                          ]
                        }
                      },
                      _vm._l(_vm.pageSizeOptions, function(pageSize) {
                        return _c(
                          "option",
                          { key: pageSize, domProps: { value: pageSize } },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(pageSize) +
                                " 件\n                  "
                            )
                          ]
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.notLoadAllDataUser,
                              expression: "notLoadAllDataUser"
                            }
                          ],
                          staticClass: "ace",
                          attrs: { type: "checkbox", checked: "" },
                          domProps: {
                            checked: Array.isArray(_vm.notLoadAllDataUser)
                              ? _vm._i(_vm.notLoadAllDataUser, null) > -1
                              : _vm.notLoadAllDataUser
                          },
                          on: {
                            click: function($event) {
                              _vm.reLoadData()
                            },
                            change: function($event) {
                              var $$a = _vm.notLoadAllDataUser,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.notLoadAllDataUser = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.notLoadAllDataUser = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.notLoadAllDataUser = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [
                          _vm._v("有効なデーターのみ表示")
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.list != null
          ? _c(
              "table",
              {
                staticClass: "table  table-bordered table-hover dataTable",
                attrs: { id: "simple-table" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "center" }, [
                      _c("label", { staticClass: "pos-rel" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectAll,
                              expression: "selectAll"
                            }
                          ],
                          staticClass: "ace",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectAll)
                              ? _vm._i(_vm.selectAll, null) > -1
                              : _vm.selectAll
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectAll,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectAll = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectAll = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_id sorting",
                        attrs: { id: "user_id" },
                        on: {
                          click: function($event) {
                            _vm.sort("userId", "user_id")
                          }
                        }
                      },
                      [_vm._v("ユーザーID")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_name sorting",
                        class: { none: _vm.checkColumnShowHide("name") },
                        attrs: { id: "user_name" },
                        on: {
                          click: function($event) {
                            _vm.sort("name", "user_name")
                          }
                        }
                      },
                      [_vm._v("ユーザー名")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_furigana sorting",
                        class: { none: _vm.checkColumnShowHide("furigana") },
                        attrs: { id: "user_furigana" },
                        on: {
                          click: function($event) {
                            _vm.sort("furigana", "user_furigana")
                          }
                        }
                      },
                      [_vm._v("ユーザー名ふりがな")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "center user_permistion sorting",
                        class: { none: _vm.checkColumnShowHide("isAdmin") },
                        attrs: { id: "user_permistion" },
                        on: {
                          click: function($event) {
                            _vm.sort("isAdmin", "user_permistion")
                          }
                        }
                      },
                      [_vm._v("組織管理権限")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "center user_isphoneadmin sorting",
                        class: {
                          none: _vm.checkColumnShowHide("isPhoneAdmin")
                        },
                        attrs: { id: "user_isphoneadmin" },
                        on: {
                          click: function($event) {
                            _vm.sort("isPhoneAdmin", "user_isphoneadmin")
                          }
                        }
                      },
                      [_vm._v("ゲート設定権限")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "center user_sharekeybevalid sorting",
                        class: {
                          none: _vm.checkColumnShowHide("shareKeyBeValid")
                        },
                        attrs: { id: "user_sharekeybevalid" },
                        on: {
                          click: function($event) {
                            _vm.sort("shareKeyBeValid", "user_sharekeybevalid")
                          }
                        }
                      },
                      [_vm._v("鍵共有権限")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "center user_status sorting",
                        class: { none: _vm.checkColumnShowHide("status") },
                        attrs: { id: "user_status" },
                        on: {
                          click: function($event) {
                            _vm.sort("isValid", "user_status")
                          }
                        }
                      },
                      [_vm._v("ステータス")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_option1 sorting",
                        class: { none: _vm.checkColumnShowHide("option1") },
                        attrs: { id: "user_option1" },
                        on: {
                          click: function($event) {
                            _vm.sort("option1", "user_option1")
                          }
                        }
                      },
                      [_vm._v("備考.1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_option2 sorting",
                        class: { none: _vm.checkColumnShowHide("option2") },
                        attrs: { id: "user_option2" },
                        on: {
                          click: function($event) {
                            _vm.sort("option2", "user_option2")
                          }
                        }
                      },
                      [_vm._v("備考.2")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_registered sorting center",
                        class: { none: _vm.checkColumnShowHide("registered") },
                        attrs: { id: "user_registered" },
                        on: {
                          click: function($event) {
                            _vm.sort("registered", "user_registered")
                          }
                        }
                      },
                      [_vm._v("登録日")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_updated sorting center",
                        class: { none: _vm.checkColumnShowHide("updated") },
                        attrs: { id: "user_updated" },
                        on: {
                          click: function($event) {
                            _vm.sort("updated", "user_updated")
                          }
                        }
                      },
                      [_vm._v("更新日")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "user_isMfaSms sorting center",
                        class: { none: _vm.checkColumnShowHide("isMfaSms") },
                        attrs: { id: "user_isMfaSms" },
                        on: {
                          click: function($event) {
                            _vm.sort("isMfaSms", "user_isMfaSms")
                          }
                        }
                      },
                      [_vm._v("SMS認証")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, index) {
                  return _c("tbody", { key: index }, [
                    _c(
                      "tr",
                      {
                        class: { selected: _vm.rowSelected(item.userId) },
                        attrs: { id: item.userId }
                      },
                      [
                        _c("td", { staticClass: "center" }, [
                          _c("label", { staticClass: "pos-rel" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedUserId,
                                  expression: "selectedUserId"
                                }
                              ],
                              staticClass: "ace",
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: item.userId,
                                checked: Array.isArray(_vm.selectedUserId)
                                  ? _vm._i(_vm.selectedUserId, item.userId) > -1
                                  : _vm.selectedUserId
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selectedUserId,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.userId,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedUserId = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedUserId = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedUserId = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "lbl" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_id",
                            staticStyle: { "word-wrap": "break-word" },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.userId) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_name",
                            class: { none: _vm.checkColumnShowHide("name") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_furigana",
                            class: {
                              none: _vm.checkColumnShowHide("furigana")
                            },
                            on: { click: _vm.showdetail }
                          },
                          [_vm._v(_vm._s(item.furigana))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "center user_permistion",
                            class: { none: _vm.checkColumnShowHide("isAdmin") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            item.isAdmin
                              ? _c("span", [_vm._v("管理者")])
                              : _c("span", [_vm._v("ユーザー")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "center user_isphoneadmin",
                            class: {
                              none: _vm.checkColumnShowHide("isPhoneAdmin")
                            },
                            on: { click: _vm.showdetail }
                          },
                          [
                            item.isPhoneAdmin
                              ? _c("span", [_vm._v("有効")])
                              : _c("span", [_vm._v("無効")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "center user_sharekeybevalid",
                            class: {
                              none: _vm.checkColumnShowHide("shareKeyBeValid")
                            },
                            on: { click: _vm.showdetail }
                          },
                          [
                            item.shareKeyBeValid
                              ? _c("span", [_vm._v("有効")])
                              : _c("span", [_vm._v("無効")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "center user_status",
                            class: { none: _vm.checkColumnShowHide("status") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            item.isValid
                              ? _c("span", [_vm._v("有効")])
                              : _c("span", [_vm._v("無効")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_option1",
                            class: { none: _vm.checkColumnShowHide("option1") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.option1) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_option2",
                            class: { none: _vm.checkColumnShowHide("option2") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.option2) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_registered center",
                            class: {
                              none: _vm.checkColumnShowHide("registered")
                            },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.converDateShort(item.registered)) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "user_updated center",
                            class: { none: _vm.checkColumnShowHide("updated") },
                            on: { click: _vm.showdetail }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.converDateShort(item.updated)) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "center user_isMfaSms",
                            class: {
                              none: _vm.checkColumnShowHide("isMfaSms")
                            },
                            on: { click: _vm.showdetail }
                          },
                          [
                            item.isMfaSms
                              ? _c("span", [_vm._v("有効")])
                              : _c("span", [_vm._v("無効")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("tr", { staticClass: "detail-row" }, [
                      _c(
                        "td",
                        { attrs: { colspan: _vm.columnCount } },
                        [
                          _c("app-user-detail", {
                            attrs: { item: item, isAdmin: _vm.isAdmin }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                })
              ],
              2
            )
          : _c(
              "table",
              {
                staticClass: "table  table-bordered table-hover dataTable",
                attrs: { id: "simple-table" }
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { attrs: { colspan: "6" } }, [
                      _vm._v(_vm._s(_vm.message))
                    ])
                  ])
                ])
              ]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pd-t-10" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _vm.pages > 0
            ? _c(
                "div",
                { staticClass: "dataTables_paginate paging_simple_numbers" },
                [
                  _c("paginate", {
                    attrs: {
                      "page-count": _vm.pages,
                      "page-range": 3,
                      "margin-pages": 2,
                      "click-handler": _vm.handleCurrentChange,
                      "prev-text": "<<",
                      "next-text": ">>",
                      "container-class": "pagination",
                      "page-class": "page-item"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v(
                  "チェックしたユーザーを一括無効化します、よろしいですか？"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successUser > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countUser) +
                        "件中" +
                        _vm._s(_vm.successUser) +
                        "件を無効化しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("無効化失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.updateAllStatus()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("ul", { staticClass: "add_btn_list" }, [
      _c(
        "li",
        [
          _c(
            "router-link",
            { staticClass: "adduser", attrs: { to: { name: "useradd" } } },
            [_c("i", { staticClass: "ace-icon fa fa-users my-float" })]
          ),
          _vm._v(" "),
          _vm._m(7)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "adduserExport",
              attrs: { to: { name: "userimport" } }
            },
            [
              _c("i", {
                staticClass: "ace-icon glyphicon glyphicon-upload my-float"
              })
            ]
          ),
          _vm._v(" "),
          _vm._m(8)
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("ユーザー一覧")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-icon search-box" }, [
      _c("input", {
        staticClass: "nav-search-input",
        attrs: {
          type: "text",
          placeholder: "選択項目にチェックして検索",
          id: "nav-search-input",
          autocomplete: "off"
        }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "ace-icon fa fa-search nav-search-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pull-right" }, [
      _c(
        "a",
        {
          staticClass: "option_button",
          attrs: {
            "data-toggle": "collapse",
            "data-parent": "#accordion",
            href: "#collapseOne",
            "aria-expanded": "false"
          }
        },
        [
          _vm._v("表示オプション \n          "),
          _c("i", {
            staticClass: "bigger-110 ace-icon fa fa-angle-down",
            attrs: {
              "data-icon-hide": "ace-icon fa fa-angle-up",
              "data-icon-show": "ace-icon fa fa-angle-down"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkbox table_items" }, [
      _c("label", [
        _c("input", {
          staticClass: "ace",
          attrs: {
            name: "user_id",
            type: "checkbox",
            disabled: "",
            checked: ""
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "lbl" }, [_vm._v(" ユーザーID")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "center" }, [
          _c("label", { staticClass: "pos-rel" }, [
            _c("input", { staticClass: "ace", attrs: { type: "checkbox" } }),
            _vm._v(" "),
            _c("span", { staticClass: "lbl" })
          ])
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザーID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザー名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザー名ふりがな")]),
        _vm._v(" "),
        _c("th", [_vm._v("権限")]),
        _vm._v(" "),
        _c("th", [_vm._v("ステータス")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("ユーザーを無効化")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "float",
        attrs: { href: "javascript:void(0)", id: "menu-share" }
      },
      [_c("i", { staticClass: "fa fa-plus my-float" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-container" }, [
      _c("div", { staticClass: "label-text" }, [_vm._v("新規ユーザー登録")]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-play label-arrow" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-container-export" }, [
      _c("div", { staticClass: "label-text" }, [
        _vm._v("CSVインポートでユーザー登録")
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-play label-arrow" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e1c2a7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e1c2a7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserList.vue
// module id = null
// module chunks = 